import { Route } from '@angular/router';
import ClientLayoutComponent from './layout/client-layout/client-layout.component';

export const appRoutes: Route[] = [
  {
    path: '',
    component: ClientLayoutComponent,
    children: [
      {
        path: '',
        data: { title: '홈' },
        loadComponent: () => import('./pages/home/home.page'),
      },
      {
        path: 'about',
        data: { title: '좋은공간 소개' },
        loadComponent: () => import('./pages/about/about.page'),
      },
      {
        path: 'history',
        data: { title: '연혁' },
        loadComponent: () => import('./pages/history/history.page'),
      },
      {
        path: 'notice',
        children: [
          {
            path: '',
            data: { title: '공지사항' },
            loadComponent: () => import('./pages/notice/notice.page'),
          },
          {
            path: ':id',
            data: { title: '공지사항 상세' },
            loadComponent: () =>
              import('./pages/notice/notice-detail/notice-detail.page'),
          },
        ],
      },
      {
        path: 'donation',
        children: [
          {
            path: '',
            data: { title: '기부사랑' },
            loadComponent: () => import('./pages/donation/donation.page'),
          },
          {
            path: ':id',
            data: { title: '기부사랑 상세' },
            loadComponent: () =>
              import('./pages/donation/donation-detail/donation-detail.page'),
          },
        ],
      },
      {
        path: 'inquiry',
        data: { title: '제휴 문의' },
        loadComponent: () => import('./pages/inquiry/inquiry.page'),
      },
      {
        path: 'policy',
        data: { title: '약관 및 정책' },
        loadComponent: () => import('./pages/policy/policy.page'),
      },
      // 없는 경로 전부 홈으로
      {
        path: '**',
        redirectTo: '',
      },
    ],
  },
];
